import React from 'react';
import { navigate } from 'gatsby';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';

const TableRow = ({ children, url, className }) => {
  return (
    <tr
      onClick={
        url
          ? () => {
              navigate(url);
            }
          : null
      }
      className={className}
      data-testid="styled-table-row"
    >
      {children}
    </tr>
  );
};

// === TableRow CSS ===
const StyledTableRow = styled(TableRow)`
  box-sizing: border-box;
  ${({ url }) =>
    url
      ? `&:hover {
    cursor: pointer;
    background: #f1f1f1;
    transition: ${vars.defaultTransition};
  }`
      : null}
`;

export default StyledTableRow;
